/* eslint-disable better-mutation/no-mutation */
import { createSlice } from '@reduxjs/toolkit';
import type { FirebaseIdToken } from 'tradera/components/messaging/firebase.types';

type AuthState = {
    firebaseIdToken?: FirebaseIdToken;
};

const initialState: AuthState = {};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        receivedFirebaseIdToken: (state, { payload }) => {
            state.firebaseIdToken = payload;
        },
    },
});

export const { receivedFirebaseIdToken } = authSlice.actions;

export default authSlice.reducer;
